import request from '@/utils/request'

const bpmModel = window.context.bpmModel
const bpmRunTime = window.context.bpmRunTime
const portal = window.context.portal

// 首页-获取待办数量
export function getTodoNumber(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getMyTodoTask`,
    method: 'post',
    data,
  })
}

// 首页-获取待阅数量
export function getTodoReadNumber(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getNoticeTodoRead`,
    method: 'post',
    data,
  })
}

//首页-获取待阅数量（新-只获取待阅，不包含已阅）
export async function getTodoUnReadNumber() {
  const params = {
    pageBean: { page: -1, pageSize: -1, total: 0 },
    sorter: [],
    querys: [],
  }
  const { getNoticeTodoReadList } = await import('./process')
  // 调用待阅事项列表接口
  const res = await getNoticeTodoReadList(params)
  // 统计isRead为0的数量
  const rows = res?.rows || []
  const unReadCount = rows.filter((item) => item.isRead === 0).length
  return unReadCount
}

// 首页-获取已办数量
export function getDoneTaskNumber(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getMyDoneTask`,
    method: 'post',
    data,
  })
}

// 首页-我的申请数量
export function getMyRequestNumber(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getMyRequest`,
    method: 'post',
    data,
  })
}

// 首页-延迟处理数量
export function getMyDelayTaskNumber(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getMyDelayTask`,
    method: 'post',
    data,
  })
}

// 首页-桑基图数据
export function getSankey(data) {
  return request({
    url: `${bpmRunTime}/runtime/homePage/v1/getSankey`,
    method: 'post',
    data,
  })
}

// 首页-获取数据应用列表
export function getAppList() {
  return request({
    url: `${portal}/portal/sysApp/v1/queryByFilter`,
    method: 'post',
    data: {
      pageBean: { page: 1, pageSize: 50, total: 0 },
      params: { menuId: '' },
    },
  })
}
